import axios from 'axios'
import { getEnvVar } from '@/utils/envUtils'

function populationToDTO(population) {
    let populationParams = {};
    population.parameters.forEach(parameter => {
        const parameterName = parameter.view.name;
        switch (parameterName) {
            case "Population Name":
                const populationName = parameter.value[0]; // populationName is like "population name  (#subjects)"
                let populationNameWithoutNumberOfSubjects = populationName.replace(/\s*\(\d+\)\s*$/, '');
                populationNameWithoutNumberOfSubjects.trimEnd();
                populationParams["name"] = populationNameWithoutNumberOfSubjects; 
                break;

            case "Population size":
                populationParams["number_of_subjects"] = parameter.value[0];
                break;

            case "Cardiac Cycle":
                populationParams["cardiac_cycle"] = parameter.value[0];
                break;
        }
    });
    return populationParams;
}


function toCustomdrugDTO(customDrugFrom) {
    const customDrug = {};
    customDrugFrom.fields.forEach(field => {
        customDrug[field.view.name] = field.value[0];
    });

    return {
        "name": customDrug["Drug name"],
        "molecular_weight": customDrug["Molecular Weight"],
        "fppb": customDrug["Free Fraction in Percent"] / 100,
        "dose": customDrug["Total Concentration"],
        "affected_ion_channels": {
            "cav12": {
                "ic50": customDrug["IC50-Cav1.2"],
                "h": customDrug["H-Cav1.2"]
            },
            "herg": {
                "ic50": customDrug["IC50-hERG"],
                "h": customDrug["H-hERG"]
            },
            "kir21": {
                "ic50": customDrug["IC50-Kir2.1"],
                "h": customDrug["H-Kir2.1"]
            },
            "kv43": {
                "ic50": customDrug["IC50-Kv4.3"],
                "h": customDrug["H-Kv4.3"]
            },
            "kvlqt1mink": {
                "ic50": customDrug["IC50-KvLQT1/minK"],
                "h": customDrug["H-KvLQT1/minK"]
            },
            "nav15late": {
                "ic50": customDrug["IC50-Nav1.5-late"],
                "h": customDrug["H-Nav1.5-late"]
            },
            "nav15peak": {
                "ic50": customDrug["IC50-Nav1.5-peak"],
                "h": customDrug["H-Nav1.5-peak"]
            },
        }
    };
}


function treatmentsToCustomDrugDTO(treatments) {
    let drugDTO = null;
    treatments.forEach(t => {
        if (t.name == "Custom Drug") {
            drugDTO = toCustomdrugDTO(t);
        }
    });
    return drugDTO;
}

function toTrialDTO(trial) {
    const populationDTO = populationToDTO(trial.cohortGeneration.population);
    const trialDTO = {
        "project_id": trial.projectId,
        "id": trial.id,
        "name": trial.name,
        "population": populationDTO,
    }
    const customDrug = treatmentsToCustomDrugDTO(trial.treatments);
    if (customDrug != null) {
        trialDTO["drug"] = customDrug;
        trialDTO["dose"] = customDrug.dose;
    }
    return trialDTO;
}

function getApolloPopulations() {
    const url = "apollo/populations"
    return ApolloAPI.get(url);
}

const ApolloAPI = axios.create({
    baseURL: getEnvVar("VUE_APP_APOLLO_URL"),
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
})

function extractIds(params) {
    return {
        projectId: params.project.id,
        trialId: params.trial.id,
        subjectTemplateId: params.subject.subject.templateId,
    }
}


export default {
    sendSimulation(trial) {
        const trialDTO = toTrialDTO(trial);

        const url = "apollo/trials/register_and_simulate"
        return ApolloAPI.post(url, trialDTO);
    },
    getApolloPopulations: getApolloPopulations,
    getTrialResults(projectId, trialId) {
        const url = `/apollo/projects/${projectId}/trials/${trialId}/results`

        return ApolloAPI.get(url)
    },
    getEcg(params) {
        
        let { projectId, trialId, subjectTemplateId } = extractIds(params)
        let url = `/apollo/projects/${projectId}/trials/${trialId}/subjects/${subjectTemplateId}/ecg`

        return ApolloAPI.get(url).then(res => {
            return res.data.xyseries[0].rows.map(row => {
                let rowObj = {}

                //TODO: sometimes is 'header', other is 'headers'- need consistency on server side!
                let headerKey = 'header' in res.data.xyseries[0] ? 'header' : 'headers'

                row.forEach((col, i) => {
                    rowObj[res.data.xyseries[0][headerKey][i]] = row[i]
                })
                return rowObj
            })
        })
    },
}
